import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import SuccessModal from '../Common/SuccessModal';
import AddEditCenter from './AddEditCenter';
import { API_CENTERS, API_DELETE_CENTER } from '../Config/ApiUrlConstant';
import { useAuth } from '../AuthContext';
import { apiJson } from '../utils/apiClient';
import { confirmAction } from '../utils/confirmAction';

const CenterMgmt = () => {
    const { canAccess } = useAuth();
    const [centerList, setCenterList] = useState([]);
    const [filteredCenters, setFilteredCenters] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const centersPerPage = 10;
    const [filters, setFilters] = useState({
        branch_no: '',
        branch_name: '',
        center_no: '',
        center_name: '',
    });
    const [message, setMessage] = useState('');
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [centerToEdit, setCenterToEdit] = useState(null);
    const [actionType, setActionType] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const closeModal = () => setSuccessModalVisible(false);

    const getAllCenters = async () => {
        try {
            setIsLoading(true);
            const { data: responseData } = await apiJson(API_CENTERS, {
                method: 'POST',
                body: JSON.stringify({}),
            });
            setCenterList(responseData.data || []);
            setFilteredCenters(responseData.data || []);
        } catch (error) {
            setMessage('Error getting center list');
            setSuccessModalVisible(true);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        void getAllCenters();
    }, []);

    const handleEditClick = (rowData, type) => {
        setCenterToEdit(type === 'edit' ? rowData : null);
        setShowModal(true);
        setActionType(type);
    };

    const handleDeleteCenter = async (centerId) => {
        if (!confirmAction('archive this center')) return;
        try {
            const { data } = await apiJson(API_DELETE_CENTER, {
                method: 'POST',
                body: JSON.stringify({ center_id: centerId }),
            });
            setMessage(data?.message || 'Center archived successfully');
            setSuccessModalVisible(true);
            await getAllCenters();
        } catch (error) {
            setMessage('Unable to delete center. It may already be linked to clients.');
            setSuccessModalVisible(true);
        }
    };

    const handleColumnFilterChange = (e) => {
        const { name, value } = e.target;
        const newFilters = { ...filters, [name]: value };
        setFilters(newFilters);

        const filtered = centerList.filter((center) =>
            center.branch_no?.toLowerCase().includes(newFilters.branch_no.toLowerCase()) &&
            center.branch_name?.toLowerCase().includes(newFilters.branch_name.toLowerCase()) &&
            center.center_no?.toLowerCase().includes(newFilters.center_no.toLowerCase()) &&
            center.center_name?.toLowerCase().includes(newFilters.center_name.toLowerCase())
        );

        setFilteredCenters(filtered);
        setCurrentPage(1);
    };

    const indexOfLastCenter = currentPage * centersPerPage;
    const indexOfFirstCenter = indexOfLastCenter - centersPerPage;
    const currentCenters = filteredCenters.slice(indexOfFirstCenter, indexOfLastCenter);
    const totalPages = Math.ceil(filteredCenters.length / centersPerPage);

    return (
        <div className="container mt-5">
            <div className="row mb-3 align-items-center">
                <div className="col-md-6 col-sm-12 float-left">
                    <h2>Centers List</h2>
                </div>
                <div className="col-md-6 col-sm-12 text-md-end text-sm-start mt-sm-2 mt-md-0 float-right">
                    {canAccess('centers', 'create') ? (
                        <button onClick={() => handleEditClick(null, 'add')} className="btn btn-primary width200">
                            Add New Center
                        </button>
                    ) : null}
                </div>
            </div>

            {isLoading ? (
                <div className="dashboard-empty-state">Loading centers...</div>
            ) : (
                <>
                    <div className="table-responsive data-table-shell">
                        <table className="table table-bordered table-striped data-table">
                            <thead>
                                <tr>
                                    <th>Sr. No</th>
                                    <th>Branch No</th>
                                    <th>Branch Name</th>
                                    <th>Center No</th>
                                    <th>Center Name</th>
                                    <th>Action</th>
                                </tr>
                                <tr>
                                    <th></th>
                                    <th><input type="text" name="branch_no" value={filters.branch_no} onChange={handleColumnFilterChange} className="form-control form-control-sm" placeholder="Search" /></th>
                                    <th><input type="text" name="branch_name" value={filters.branch_name} onChange={handleColumnFilterChange} className="form-control form-control-sm" placeholder="Search" /></th>
                                    <th><input type="text" name="center_no" value={filters.center_no} onChange={handleColumnFilterChange} className="form-control form-control-sm" placeholder="Search" /></th>
                                    <th><input type="text" name="center_name" value={filters.center_name} onChange={handleColumnFilterChange} className="form-control form-control-sm" placeholder="Search" /></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentCenters.length > 0 ? (
                                    currentCenters.map((data, index) => (
                                        <tr key={data.id}>
                                            <td>{indexOfFirstCenter + index + 1}</td>
                                            <td>{data.branch_no}</td>
                                            <td>{data.branch_name}</td>
                                            <td>{data.center_no}</td>
                                            <td>{data.center_name}</td>
                                            <td>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {canAccess('centers', 'edit') ? (
                                                        <button onClick={() => handleEditClick(data, 'edit')} className="btn btn-warning btn-sm">
                                                            Edit
                                                        </button>
                                                    ) : null}
                                                    {canAccess('centers', 'delete') ? (
                                                        <button onClick={() => handleDeleteCenter(data.id)} className="btn btn-danger btn-sm">
                                                            Delete
                                                        </button>
                                                    ) : null}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">No centers found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <nav className="d-flex justify-content-center">
                        <ul className="pagination">
                            {Array.from({ length: totalPages }, (_, i) => (
                                <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                    <button onClick={() => setCurrentPage(i + 1)} className="page-link">
                                        {i + 1}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </>
            )}

            {successModalVisible && <SuccessModal message={message} onClose={closeModal} />}
            <AddEditCenter
                showAddEdit={showModal}
                setShowAddEdit={setShowModal}
                centerToEdit={centerToEdit}
                actionType={actionType}
                refreshCenters={getAllCenters}
            />
        </div>
    );
};

export default CenterMgmt;
